import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent'
const AiDomainExpertise = () => {
    return (
        <div className='row pt-20 px-10 mb-20'>
            <div className='col-md-12 text-center'>
                <SectionHeader_2
                    title= {`Domain Expertise`}
                />
            </div>
            <div className='row mt-20 border px-10 br-20'>
                <div className='col-md-7 pe-15 m-auto'>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Our team has end-to-end implementation experience in leading companies across the globe.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Cross-functional expertise among Sales, Marketing, Credit & Risk, Market mix, Fraud Analytics, Segmentation, Optimization and more.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-5 text-end m-auto'>
                    <img src="/assets/img/developer-guide.jpg" alt="app image" className="radius-20 p-10 pe-0" style={{}} />
                </div>
            </div>
        </div>
    )
}

export {AiDomainExpertise}